<!--  -->

<template>
  <div class="content">
    <!-- banner -->
    <div class="banner">
      <img src="http://www.hitalgroup.com/img/banner.png" @click="jump" alt="" />
    </div>
    <!-- 视频模块 -->
    <div class="void">
      <div class="left video_text">
        <span></span>

        <video controls="controls" :autoplay="true" muted>
          <source src="http://www.hitalgroup.com/mp4/index.mp4?c" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div class="right">
        <img class="our" src="../../assets/img/index/our.png" alt="" />
        <div class="company_info">
          <div class="company_name">湖南浩通科技有限公司</div>
          <div class="compay_text padding">
            专业的流通领域信息化服务提供商，
            是推动国际物流、仓储和通关行业走向互联化、智能化、数智化应用的软件服务企业。
            公司聚焦跨境贸易领域数字与信息化服务，在跨境电商、国际货运、
            仓储配送、智慧通关等细分行业，为客户提供安全、领先、可持续进化的产品、技术和解决方案。

          </div>
          <div class="compay_text">
            公司业务范围涵盖跨境电商、国际货运、仓储配送、智慧通关等SaaS服务；企业关务、仓储和通关等软件对接服务；企业软件开发、网站建设、商城建设、品牌设计等技术服务。助力跨境贸易领域数字化转型，
            支撑行业高质量发展，致力于成为业内领先的数字化解决方案服务提供商。
          </div>
        </div>
        <img class="about" src="../../assets/img/index/About.png" alt="" />
      </div>
    </div>
    <!-- 解决方案 -->
    <div class="solve card" v-if="false">
      <div class="left">
        <div class="all_text">
          <img src="../../assets/img/index/ico.png" alt="" />
          <div class="text">
            为您提供专业的 <br />
            流通领域信息化服务 <br />
            解决方案
          </div>
          <div class="row"></div>
        </div>
        <!-- 文案 -->
        <div class="some_info">
          <div class="text">
            公司业务范围有“SaaS服务”、“对接服务”、“技术服务”三种，
            满足流通领域企业信息化服务所需。
          </div>
          <div class="text padding_top">
            助力跨境贸易领域数字化转型，支撑行业高质量发展，
            致力于成为业内领先的数字化解决方案服务提供商。
          </div>
        </div>
        <a href="#" class="a" @click="topUrl(2, '/about')">
          <div class="bot">
            了解更多
            <span class="iconfont icon-arrow-right-copy-copy ioc"></span>
          </div>
        </a>
      </div>
      <div class="right">
        <div class="li height450">
          <img class="img" src="../../assets/img/index/ioc1.png" alt="" />
          <div class="text_info">
            <div class="title">技术服务</div>
            <div class="text_li padding-top">
              <div class="cirl"></div>
              <div class="text">企业软件开发</div>
            </div>
            <div class="text_li">
              <div class="cirl"></div>
              <div class="text">网站建设</div>
            </div>
            <div class="text_li">
              <div class="cirl"></div>
              <div class="text">商城建设</div>
            </div>
            <div class="text_li">
              <div class="cirl"></div>
              <div class="text">品牌设计</div>
            </div>
          </div>
        </div>
        <div class="right_li">
          <div class="li height360">
            <img class="img" src="../../assets/img/index/ico2.png" alt="" />
            <div class="text_info">
              <div class="title">SaaS服务</div>
              <div class="text_li padding-top">
                <div class="text">
                  涵盖跨境电商、国际货运、仓储配送、智慧通关等SaaS服务。
                </div>
              </div>
            </div>
          </div>
          <div class="li margin60 height360">
            <img class="img" src="../../assets/img/index/ioc1.png" alt="" />
            <div class="text_info">
              <div class="title">对接服务</div>
              <div class="text_li padding-top">
                <div class="text">涵盖企业关务、仓储和通关等软件对接服务。</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 我们的服务项目 -->
    <!-- 服务项目 -->
    <div class="serve card">
      <Link text="我们的服务项目" />

      <div class="list">
        <div class="li" v-for="(item, index) in list_server" :key="index" :style="item.bg">
          <div class="title">
            {{ item.title }}
          </div>
          <div class="text">
            <div class="text_li" v-for="(items, indexs) in item.text" :key="indexs">
              {{ items }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 五大产品 -->
    <div class="product">
      <Link text="五大产品" />
      <div class="card">
        <div id="certify">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide certify_bj1" v-for="(item, index) in swiper" :key="index">
                <div class="div_bj">
                  <div class="Item">
                    <div class="top">
                      <img :src="item.icon" alt="">
                    </div>
                    <div class="center">
                      <div class="row"></div>
                      <div class="title ">
                        {{ item.title }}</div>
                      <div class="row"></div>
                    </div>
                    <div class="img">
                      <!--  v-viewer="options"  :data-src="item.imgs" -->
                      <img :key="index" :src="item.img" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
    <div class="bgLoding" v-if="dialogVisible" @click="dialogVisible = false">
      <img :src="bgLodingImg" />
    </div>

    <!-- 软著证书 -->
    <div class="certificate ">
      <div class="">
        <div class="top_all">
          <img src="../../assets/img/index/ico.png" alt="" />
          <div class="text fff">荣誉资质</div>
        </div>
        <div class="img_info card" >
          <!-- <el-row >
            <el-col  :md="8" :lg="8">
              <img src="../../assets/img/index/rz1.png" alt="" />
            </el-col>
            <el-col :md="8" :lg="8">
              <img src="../../assets/img/index/rz2.png" alt="" />
            </el-col>
            <el-col :md="8" :lg="8"
              > <img src="../../assets/img/index/rz2.png" alt="" />
            </el-col>
          </el-row> -->
          <div class="item">
            <img src="../../assets/index/ry1.png" alt="" />
          </div>
          <div class="item" >
            <img src="../../assets/index/ry2.png" alt="" />
          </div>
          <div class="item">
            <img src="../../assets/index/ry3.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 合作流程 -->
    <div class="cooperation">
      <div class="top_all">
        <img src="../../assets/img/index/ico.png" alt="" />
        <div class="text">合作流程</div>
      </div>
      <!-- 线条 -->
      <div class="line">
        <div class="line_row">
          <img class="line_img" src="../../assets/img/index/2.png" alt="" />
        </div>

        <div class="list">
          <div class="item" v-for="(item, index) in list" :key="index"
            :style="'margin-top:' + item.top + '%;left:' + item.left + '%;'">
            <div class="circular_big">
              <div class="circular_ms">
                <p class="iconfont ico" :style="'font-size:' + item.size + 'px'" :class="item.iocn"></p>
              </div>
            </div>
            <div class="text_info">
              <p class="text color">
                {{ item.title }}
              </p>
              <p class="text" style="width:185px">
                {{ item.text }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!--按钮 -->

      <div class="fot"></div>
    </div>
  </div>
</template>

<script>
import Link from "../../components/all_text.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: { Link },
  data() {
    //这里存放数据
    return {
      list: [
        {
          title: "分析需求",
          text: "收集客户需求，进行需求分析以及制定初步方案。",
          iocn: "icon-lianxi",
          top: "-7",
          left: "8",
          size: "40",
        },
        {
          title: "确认方案",
          text: "客户确认需求，双方制定项目实施计划，并确定合作意向。",
          iocn: "icon-qiandinghetong",
          top: "-0",
          left: "20",
          size: "35",
        },
        {
          title: "签署合同",
          text: "双方达成统一意见，签署项目合同，项目正式启动。",
          iocn: "icon-xinzengwaijiagong",
          top: "-6",
          left: "33",
          size: "35",
        },
        {
          title: "产品研发",
          text: "根据确认的设计方案，进行产品原型设计、研发、测试。",
          iocn: "icon-qidong",
          top: "0",
          left: "45",
          size: "35",
        },
        {
          title: "产品上线",
          text: "完成测试后，现场进行产品的安装、调试、培训。",
          iocn: "icon-wancheng",
          top: "-1",
          left: "58",
          size: "33",
        },
        {
          title: "产品验收",
          text: "客户验收软件所包含的功能，并按照合同规定支付尾款。",
          iocn: "icon-shangxian",
          top: "-6",
          left: "70",
          size: "30",
        },
        {
          title: "运维服务",
          text: "除保证系统正常运行外，根据客户需求长期做系统维护。",
          iocn: "icon-yunwei",
          top: "1",
          left: "83",
          size: "33",
        },
      ],
      list_server: [
        {
          bg:
            " background: url(" +
            require("../../assets/img/serve/1.png") +
            "); no-repeat; background-size: 100% 100%;",
          title: "技术服务",
          text: ["软件定制开发", "小程序开发", "企业网站建设", "商城建设"],
        },
        {
          bg:
            " background: url(" +
            require("../../assets/img/serve/2.png") +
            ");no-repeat; background-size: 100% 100%;",
          title: "设计服务",
          text: ["UI设计", "logo设计", "美工设计", "平面设计"],
        },
        {
          bg:
            " background: url(" +
            require("../../assets/img/serve/3.png") +
            ");no-repeat; background-size: 100% 100%;",
          title: "视频服务",
          text: ["宣传片", "短视频", "视频剪辑", "PPT制作"],
        },
      ],
      swiper: [
        {
          icon: require('../../assets/img/swiper/icon.png'),
          title: ' 关务管理系统',
          img: require('../../assets/img/swiper/1.png'),
          imgs: require('../../assets/img/swiper/1-1.png')
        },
        {
          icon: require('../../assets/img/swiper/icon.png'),
          title: '仓库管理系统',
          img: require('../../assets/img/swiper/2.png'),
          imgs: require('../../assets/img/swiper/2-2.png')
        }, {
          icon: require('../../assets/img/swiper/icon.png'),
          title: '货运管理系统',
          img: require('../../assets/img/swiper/3.png'),
          imgs: require('../../assets/img/swiper/3-3.png')
        }, {
          icon: require('../../assets/img/swiper/icon.png'),
          title: '货运教学平台',
          img: require('../../assets/img/swiper/4.png'),
          imgs: require('../../assets/img/swiper/4-4.png')
        }, {
          icon: require('../../assets/img/swiper/icon.png'),
          title: '周期购电商系统',
          img: require('../../assets/img/swiper/5.png'),
          imgs: require('../../assets/img/swiper/5-5.png')
        }
      ],
      active: 6,
      photo: ['../../assets/img/swiper/1-1.png', '../../assets/img/swiper/1-1.png'],
      options: {
        url: 'data-src'
      },
      dialogVisible: false,

    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    open(e) {
      this.dialogVisible = true;
      this.bgLodingImg = e;
      console.log(e)
    },
    //跳转
    topUrl(index, url, text) {
      this.$router.push(url);

      this.$store.state.current = index;
      this.drawer = false;
      this.current = index;
      localStorage.setItem("current", this.current);
      this.nav_current = text;
    },
    // 
    swiperImg(e) {
      // this.dialogVisible=true;
      // this.bgLodingImg=e;
      // console.log(e)
    },
    // 底部
    jump(index) {
      let jump = document.getElementById("d_jump");
      // 获取需要滚动的距离
      let total = jump.offsetTop;
      console.log(jump.offsetTop);

      // Chrome
      document.body.scrollTop = total;
      // Firefox
      document.documentElement.scrollTop = total;
      // Safari
      window.pageYOffset = total;
    },
    lun() {
      var that = this;
      // var mySwiper = 
      setTimeout(() => {
        var mySwiper = new Swiper('.swiper-container', {
          // watchSlidesProgress: true,
          slidesPerView: 'auto',
          centeredSlides: true,
          loop: true,
          // autoplay:true,
          // loopedSlides: 5,
          // autoplay: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          on: {
            slideChangeTransitionStart: function () {
              that.active = this.activeIndex;
              $('.swiper-container .swiper-slide .title').removeClass('activeColor');
              $('.swiper-container .swiper-slide .title').eq(that.active).addClass('activeColor');
            },

            progress: function (progress) {
              for (let i = 0; i < this.slides.length; i++) {

                var slide = this.slides.eq(i);
                var slideProgress = this.slides[i].progress;
                var modify = 1;
                if (Math.abs(slideProgress) > 1) {
                  modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                }
                var translate = slideProgress * modify * 200 + 'px';
                if (translate == "200px") {
                  translate = "70px";
                }
                if (translate == "-200px") {
                  translate = "-70px";
                }
                if (translate == "520px") {
                  translate = "220px";
                }
                if (translate == "-520px") {
                  translate = "-220px";
                }
                var scale = 1 - Math.abs(slideProgress) / 5;
                var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                slide.css('zIndex', zIndex);
                slide.css('opacity', 1);
                if (Math.abs(slideProgress) > 3) {
                  slide.css('opacity', 1);
                }
              }
            },
            setTransition: function (transition) {
              for (var i = 0; i < this.slides.length; i++) {
                var slide = this.slides.eq(i);
                slide.transition(transition);
              }
            }
          }
        });
        // 给每个swiper-slide绑定点击事件
        document.querySelectorAll('.swiper-slide').forEach((slide, index) => {
          slide.addEventListener('click', function () {
            that.dialogVisible = true;
            that.bgLodingImg = that.swiper[Number(index) - 5].imgs;
            console.log(index)
            // 当点击swiper-slide时，切换到对应的slide
            // mySwiper.slideTo(index, 100); // 第二个参数是切换动画时长(单位ms)，0代表无动画直接切换
          });
        });

      }, 100);


    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    localStorage.setItem("current", 0);
    // 轮播图

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.initVideo(); //初始化视频播放器
    this.lun();


  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped lang='less'>
@import url(../index/pc);
</style>

<style scoped lang='css'>
@import url(../../assets/js/hital.css);

.bgLoding {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .5);
  top: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

}

.bgLoding img {
  width: 70%;
  height: 90%;
  object-fit: contain
}
</style>
